const bundle = {
  close: () => 'إغلاق',
  error: () => 'خطأ',
  warn: () => 'تحذير',
  info: () => 'معلومات',
  confirmation: () => 'تأكيد',
  progressIndeterminate: () => 'قيد التقدم',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'بين ' + p['FROM_SECTION'] + ' و' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. لم يتم العثور على مقاطع مطابقة.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'اضغط على enter لتحديد قيمة.',
  indexer_touchInstructionText: () =>
    'انقر نقرًا مزدوجًا واستمر في الضغط للدخول في وضع الإيماء، ثم اسحب لأعلى أو لأسفل لتعديل القيمة.',
  inputPassword_show: () => 'إظهار كلمة السر',
  inputPassword_hide: () => 'إخفاء كلمة السر',
  inputPassword_hidden: () => 'تم إخفاء كلمة السر',
  formControl_clear: () => 'مسح',
  formControl_loading: () => 'جارٍ التحميل',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'تم تجاوز الحد الأقصى للطول ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'يتبقى ' + p['CHARACTER_COUNT'] + ' من الحروف.',
  select_noMatchesFound: () => 'لم يتم العثور على عناصر مطابقة.',
  select_oneMatchFound: () => 'تم العثور على عنصر مطابق واحد',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'تم العثور على ' + p['TOTAL_SIZE'] + ' من المطابقات',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'تم العثور على ' + p['TOTAL_SIZE'] + ' من المطابقات أو أكثر',
  selectMultiple_showSelectedValues: () => 'عرض القيم المحددة فقط.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'تم تحديد ' + p['VALUE_COUNT'] + ' من القيم.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selector_selected: () => 'تم تحديد مربع الاختيار',
  selector_unselected: () => 'لم يتم تحديد مربع الاختيار',
  userAssistance_learnMore: () => 'تعرف على المزيد',
  userAssistance_required: () => 'مطلوب',
  filePicker_singleFileUploadError: () => 'تحميل ملف واحد في كل مرة',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'يتعذر عليك تحميل ملفات من النوع ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'يتعذر عليك تحميل ملفات من النوع ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'غير معروف',
  filePicker_dropzonePrimaryText: () => 'سحب وإسقاط',
  filePicker_dropzoneSecondaryText: () => 'تحديد ملف أو إسقاط واحد هنا',
  filePicker_dropzoneSecondaryTextMultiple: () => 'تحديد الملفات أو إسقاطها هنا',
  filePicker_addFiles: () => 'إضافة ملفات',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'زيادة',
  inputNumber_decrease: () => 'تقليل',
  inputNumber_converterParseError: () => 'Enter a number.',
  noData_message: () => 'لا توجد عناصر لعرضها',
  message_navigationFromMessagesRegion: () =>
    'دخول منطقة الرسائل. اضغط على F6 للعودة إلى العنصر السابق محل التركيز.',
  message_navigationToMessagesRegion: () =>
    'تشتمل منطقة الرسائل على رسائل جديدة. اضغط على F6 للانتقال إلى منطقة أحدث الرسائل.',
  messageToast_allMessagesClosed: () => 'تم إغلاق كل الرسائل المؤقتة.'
};
export default bundle;
